if (module.hot) {
  module.hot.accept();
}

import './modules/BenefitsBar';
import './modules/ToggleTarget';
import './modules/IsSticky';
import './modules/Accordion';
import './modules/DateCountDown';
import './modules/VideoPlayer';
import './modules/VideoBanner';
import './modules/Gallery';
import './modules/Tabs';
import './modules/ScrollSpy';
import './modules/Navigation';
import './modules/Modal';
import './modules/AddClassOnScroll';
import './modules/LazyScript';
import './modules/CookieBar';
// import './components/FormValidator';

import './modules/stripe';
import './modules/vue';

// Make sure image are visible when printing
window.onbeforeprint = () => {
  const imgs = document.querySelectorAll('img');
  imgs.forEach(img => img.removeAttribute('loading') )
};